import React from 'react';

const StyledSelect = ({ 
  children, 
  className = '',
  variant = 'default',
  ...props 
}) => {
  const baseClasses = `
    w-full px-4 py-3 pr-10 bg-gray-100 border border-gray-300 rounded-lg shadow-sm
    text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
    hover:bg-gray-200 transition-colors duration-200
    appearance-none cursor-pointer
    [&::-ms-expand]:hidden
  `;

  const variantClasses = {
    default: '',
    slate: 'bg-slate-100 border-slate-300 text-slate-800 focus:ring-slate-500 focus:border-slate-500 hover:bg-slate-200',
    green: 'bg-green-50 border-green-300 text-green-800 focus:ring-green-500 focus:border-green-500 hover:bg-green-100',
    blue: 'bg-blue-50 border-blue-300 text-blue-800 focus:ring-blue-500 focus:border-blue-500 hover:bg-blue-100'
  };

  return (
    <div className="relative">
      <select
        className={`${baseClasses} ${variantClasses[variant]} ${className}`}
        style={{
          backgroundImage: 'none',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          appearance: 'none'
        }}
        {...props}
      >
        {children}
      </select>
      {/* Custom Arrow */}
      <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
        <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
};

export default StyledSelect;